import { ComponentRef, EventEmitter, Injectable, Type, ViewContainerRef } from '@angular/core';
import { from, Observable, Subject, Subscription } from 'rxjs';
import { DSTFormState } from '../../../shared/models/dst-form-state.model';
import { TrackerTabState } from '../../tracker-tabs.service';

@Injectable({
  providedIn: 'root'
})
export class DSTDynamicComponentResolverService {

  private _onDisclosureSave: Subject<DSTSavePayload> = new Subject<DSTSavePayload>();
  private _onDisclosureCancel: Subject<null> = new Subject<null>();

  get onDisclosureSave(): Observable<DSTSavePayload> {
    return this._onDisclosureSave.asObservable();
  }

  get onDisclosureCancel(): Observable<null> {
    return this._onDisclosureCancel.asObservable();
  }

  resolve(vcr: ViewContainerRef, cl: ComponentLoader): void {
    from(cl.loadChildren()).subscribe((componentType: Type<unknown>) => {
      if (!componentType) {
        console.error('[DSTDynamicComponentResolver] loadChildren resolved to an empty component type.');
        return;
      }

      vcr.clear();
      const ref: ComponentRef<unknown> = vcr.createComponent(componentType, {
        injector: vcr.injector,
      });
      const onSave: EventEmitter<DSTSavePayload> | undefined = (ref.instance as { onSave?: EventEmitter<DSTSavePayload> }).onSave;
      const onCancel: EventEmitter<null> | undefined = (ref.instance as { onCancel?: EventEmitter<null> }).onCancel;
      // [FIX: ObjectUnsubscribedError] store the Subscription returned by subscribe(),
      // then unsubscribe the Subscription on destroy — NOT the EventEmitter/Subject itself.
      // Old code called onSave?.unsubscribe() which killed the Subject permanently.
      const saveSub: Subscription | undefined = onSave?.subscribe((payload: DSTSavePayload) => {
        this._onDisclosureSave.next(payload);
      });
      const cancelSub: Subscription | undefined = onCancel?.subscribe(() => {
        this._onDisclosureCancel.next(null);
      });
      ref.onDestroy(() => {
        saveSub?.unsubscribe();
        cancelSub?.unsubscribe();
      });
    });
  }

}

interface ComponentLoader {
  loadChildren: () => Promise<Type<unknown>>;
}

export interface DSTSavePayload {
  trackerTab: TrackerTabState;
  childFormStates: DSTFormState[];
  redirectToChild: boolean;
}

export enum TemplateComponents {

}
